export class Chart {
    labels: string[];
    data: number[];
    type: string;
    legend: boolean;

    constructor() {
        this.labels = [];
        this.data = [];
        this.type = 'line';
        this.legend = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Chart.ts